<template>
  <div class="swiper-card card-thread">
    <h1>{{ slide.content.name }}</h1>
    <p>{{ slide.content.text }}</p>

    <div class="hero-meta">
      <div class="thread-profile">
        <div class="thread-profile-image">
          <img :src="slide.content.author.avatar" :alt="slide.content.author.name">
        </div>
        <div class="thread-profile-action">
          <span class="name">{{ slide.content.author.name }}</span>
        </div>
      </div>

      <div class="stats">
        <div><span class="label">Updated</span><span class="stat">{{ slide.content.updated | ago }}</span></div>
        <span class="spacer">•</span>
        <div><span class="stat">{{ slide.content.elements.length }}</span><span class="label">clips</span></div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    props: {
      slide: {
        type: Object,
      },
    },

    mounted () {
      // Select a random image from elements
      if (this.slide.content.element_images.length > 0) {
        const idx = Math.floor(Math.random() * this.slide.content.element_images.length);
        this.$emit('featureImage', this.slide.content.element_images[idx]);
      }

      // Update swiper and enable next
      this.$emit('swiperUpdate');
      this.$emit('enableNextAction');
    },

    computed: {
      // getSlug() {
      //   const slug = this.$route.params.stack;
      //   return slug ? slug.replace(/^thread:/, '') : ''
      // },

      // paper() {
      //   return this.$store.getters.getThread(this.getSlug);
      // },

      // getAuthor() {
      //   return this.slide.content.author || {};
      // },

      // getPaper() {
      //   return this.paper?.slug ? this.paper : {
      //     name: '',
      //     comments: [],
      //     elements: [],
      //   };
      // },

      // getElements() {
      //   return this.paper?.elements || [];
      // },

      // isLoggedIn() {
      //   return this.$store.getters.isLoggedIn;
      // },
    },

    // watch: {
    //   thread: {
    //     handler() {
    //       this.$emit('swiperUpdate');
    //     },
    //     deep: true,
    //   }
    // }
  }
</script>

<style lang="scss" scoped>
  @import 'src/assets/scss/v5_stacks.scss';

  .card-thread {
    padding: 2rem 0 0 0;
    text-align: center;

    h1 {
      text-wrap: balance;
    }

    p {
      text-wrap: balance;
    }
  }

  .hero-meta {
    @include typo-size-small;
    display: flex;
    flex-direction: column;
    margin-top: 1rem;

    @media (min-width: 525px) {
      flex-direction: row;
      align-items: center;
    }

    .thread-profile {
      display: flex;
      align-items: center;
      justify-content: center;
      margin-right: 1em;
      margin-bottom: 1rem;
      padding-bottom: 1rem;
      border-bottom: 1px solid rgba($neutral-400, 0.1);

      .thread-profile-image {
        width: 2rem;
        height: 2rem;

        img {
          width: 100%;
          height: 100%;
          object-fit: cover;
          border-radius: 50%;
        }
      }

      .thread-profile-action {
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        margin-left: 0;
        font-size: 1rem;
        gap: 0.25rem;

        .name {
          font-weight: bold;
          margin-left: 8px;
          margin-right: 8px;
          padding-top: 3px;
        }

        button {
          @include action-btn;
        }
      }
    }

    .stats {
      display: flex;
      justify-content: center;
      position: relative;

      .spacer {
        margin: 2px 0.75rem 0 0.75rem;
      }

      div span:first-child {
        margin-right: 0.5em;
      }

      .label, .stat {
        font-size: 0.8rem;
      }

      .label {
        font-weight: normal;
      }

      .stat {
        font-weight: bold;
      }
    }
  }
</style>